module.exports = __webpack_public_path__ + "static/media/one.7398495c.png";